module.exports = __webpack_public_path__ + "static/media/12.2735a763.jpg";